export default class Navigation {
    constructor(options) {
        const _defaults = {
            headerDropdownTrigger: ".js-header-dropdown-trigger, .js-header-nav-trigger",
            headerMobileDropdownTrigger: ".js-header-mobile-dropdown-trigger",
            navTrigger: '.js-nav-trigger',
            nav: '.js-nav'
        }
        this.defaults = Object.assign({}, _defaults, options);
    }


    init() {
        this.toggleNav();
        this.headerDropdown();
    }

    toggleNav() {
        this.getNavTrigger().on('click', () => {
            this.getNavTrigger().toggleClass('is-active');
            this.getNav().toggleClass('is-active');
            $('body').toggleClass('lock')
        });
    }

    headerDropdown() {
        let _self = this;
        let toggleHeaderDropdown = function () {
            if (window.innerWidth > 1280) {
                _self.getHeaderDropdownTrigger().on('mouseenter', function () {
                    $(this).addClass('is-active');
                    $(this).find('.js-header-dropdown').first().addClass('is-active');
                }).on('mouseleave', function (e) {
                    $(this).removeClass('is-active');
                    $(this).find('.js-header-dropdown').first().removeClass('is-active');
                });
            } else {
                $('.js-header-dropdown-trigger').on('click', function (e) {
                    // e.preventDefault();
                    e.stopPropagation();
                    $(this).toggleClass('is-active');
                    $(this).find('.js-header-dropdown').first().toggleClass('is-active');
                });
                _self.getHeaderMobileDropdownTrigger().on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $(this).toggleClass('is-active');
                    $(this).closest('.js-header-nav-trigger').find('.js-header-dropdown').first().toggleClass('is-active');
                });
            }
        }

        toggleHeaderDropdown();

        window.onresize = () => {
            toggleHeaderDropdown();
        };
        _self.getHeaderMobileDropdownTrigger().each(function () {
            if ($(this).closest('.js-header-nav-trigger').find('.js-header-dropdown').length == 0) {
                $(this).addClass('hide')
            }
        })
    }


    getNavTrigger() {
        return $(this.defaults.navTrigger);
    }

    getNav() {
        return $(this.defaults.nav);
    }

    getHeaderDropdownTrigger() {
        return $(this.defaults.headerDropdownTrigger);
    }

    getHeaderMobileDropdownTrigger() {
        return $(this.defaults.headerMobileDropdownTrigger);
    }
}


// WEBPACK FOOTER //
// ./static/js/components/Navigation.js